import React, { createContext, useContext, useState } from "react";
import { ConfigProvider, theme as antTheme } from "antd";
import {HeartTwoTone, MoonOutlined, SunOutlined} from "@ant-design/icons";

const themes = [
    {
        key: "default",
        name: "Default",
        algorithm: antTheme.defaultAlgorithm,
        color: "#1677ff",
        bgColor: "#EDF1F7",
        textColor: "#000000",
        borderRadius: 8,
        image: <SunOutlined />
    },
    {
        key: "dark",
        name: "Dark",
        algorithm: antTheme.darkAlgorithm,
        color: "#1677ff",
        bgColor: "#000000",
        textColor: "#ffffff",
        borderRadius: 8,
        image: <MoonOutlined />
    },
    {
        key: "document",
        name: "Document",
        algorithm: antTheme.defaultAlgorithm,
        color: "#52c41a",
        bgColor: "#f6ffed",
        textColor: "#000000",
        borderRadius: 8,
        image: <HeartTwoTone twoToneColor="#52c41a" />
    },
    {
        key: "blossom",
        name: "Blossom",
        algorithm: antTheme.defaultAlgorithm,
        color: "#eb2f96",
        bgColor: "#fff0f6",
        textColor: "#000000",
        borderRadius: 8,
        image: <HeartTwoTone twoToneColor="#eb2f96" />
    },
    {
        key: "v4",
        name: "V4 Theme",
        algorithm: antTheme.defaultAlgorithm,
        color: "#1677ff",
        bgColor: "#e6f4ff",
        textColor: "#000000",
        borderRadius: 8,
        image: <HeartTwoTone twoToneColor="#1677ff" />

    },
];

export const ThemeContext = createContext({
    theme: "default",
    setTheme: () => {},
    themes: themes,
    selectedTheme: "#EDF1F7"
});

export const ThemeProvider = ({ children }) => {
    const [currentTheme, setCurrentTheme] = useState(localStorage.getItem("theme") || "default");


    const changeTheme = (themeKey) => {
        setCurrentTheme(themeKey);
        localStorage.setItem("theme", themeKey);
    };

    const selectedTheme = themes.find(t => t.key === currentTheme) || themes[0];

    return (
        <ThemeContext.Provider value={{
            theme: currentTheme,
            setTheme: changeTheme,
            themes: themes,
            selectedTheme: selectedTheme.bgColor,

        }}>
            <ConfigProvider
                theme={{
                    algorithm: selectedTheme.algorithm || antTheme.defaultAlgorithm,
                    token: {
                        colorPrimary: selectedTheme.color,
                    },
                    components: {
                        Breadcrumb: {
                            separatorMargin: 4,
                        },
                    },
                }}
            >
                {children}
            </ConfigProvider>
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);